<ion-content class="ion-padding">
  <ion-list lines="none">
    <ion-button
      (click)="modalController.dismiss()"
      fill="clear"
    >
      <ion-icon
        size="large"
        name="close"
        slot="icon-only"
        color="primary"
      ></ion-icon>
    </ion-button>
    <ion-item>
      <ion-label
        class="ion-text-wrap"
        [innerHTML]="item?.title"
      ></ion-label>
    </ion-item>
    <ion-item>
      <ion-label
        class="ion-text-wrap"
        [innerHTML]="item?.message"
      ></ion-label>
    </ion-item>
    <ion-item></ion-item>
    <ion-item *ngFor="let action of item?.actions">
      <ion-button
        [color]="action.color"
        size="default"
        (click)="buttonClick(action)"
      >
        {{ action.title }}
      </ion-button>
    </ion-item>
  </ion-list>
</ion-content>
